import { createApiHooks } from '@apis/next/common';
import { CustomsRequestLog } from '@models/next/CustomsRequestLog';
import { z } from 'zod';

export const customsRequestLogApis = createApiHooks('/customs-request-log', [
  {
    method: 'get',
    path: '/',
    parameters: [
      {
        type: 'Query',
        name: 'customs_request',
        schema: z.string(),
      },
    ],
    response: CustomsRequestLog.array(),
  },
]);

export const dashboardCustomsRequestLogApis = createApiHooks('/dashboard/customs-request-log', [
  {
    method: 'get',
    path: '/:d2d_no',
    parameters: [
      {
        type: 'Path',
        name: 'd2d_no',
        schema: z.string(),
      },
    ],
    response: CustomsRequestLog.array(),
  },
]);
